import script from "./HistoryErrorsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryErrorsModal.vue?vue&type=script&setup=true&lang=js"

import "./HistoryErrorsModal.vue?vue&type=style&index=0&id=d4bc5cf8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4bc5cf8"]])

export default __exports__